import { Slider as BaseSlider } from '@base-ui/react/slider';
import { cx } from '@/cva.config';

export interface SliderProps {
  className?: string;
  disabled?: boolean;
  max?: number;
  min?: number;
  onChange: (value: number) => void;
  step?: number;
  value: number;
}

export const Slider = ({
  className,
  disabled,
  max,
  min,
  onChange,
  step,
  value,
}: SliderProps) => (
  <BaseSlider.Root
    className={cx(
      'relative flex h-4 w-full touch-none items-center select-none',
      className,
    )}
    disabled={disabled}
    max={max}
    min={min}
    onValueChange={(next) =>
      onChange(Array.isArray(next) ? (next[0] ?? 0) : next)
    }
    step={step}
    value={value}
  >
    <BaseSlider.Control className="relative h-1.5 w-full">
      <BaseSlider.Track className="absolute inset-0 h-full rounded-full bg-border">
        <BaseSlider.Indicator className="rounded-full bg-accent" />
      </BaseSlider.Track>
      <BaseSlider.Thumb className="block size-3.5 -translate-y-1/2 rounded-full border border-accent bg-accent shadow-sm focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-surface" />
    </BaseSlider.Control>
  </BaseSlider.Root>
);
